import { get, } from '.';

export function GetPostalCodes(options = {}) {
	return get<any>("/app/api/postal_codes", options);
}